import { normalize } from 'normalizr'
import { pathOr } from 'ramda'
import { arrayOfCategories } from '../../categorySchema'

export default categories => {
    const categoriesData = pathOr([], ['_embedded', 'bookingCategories'], categories)
    return { ...normalize(categoriesData, arrayOfCategories) }
}



// WEBPACK FOOTER //
// ./src/adapters/parsers/bookingParsers/bookingCategories.js